document.addEventListener('DOMContentLoaded', () => {
    function storageAvailable(type) {
        let storage;
        try {
            storage = window[type];
            const x = "__storage_test__";
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return (
                e instanceof DOMException &&
                e.name === "QuotaExceededError" &&
                // acknowledge QuotaExceededError only if there's something already stored
                storage &&
                storage.length !== 0
            );
        }
    }

    if (storageAvailable("localStorage")) {
        console.log("localStorage is available");
    } else {
        console.log("localStorage NOT available");
        alert("Your browser does not support localStorage. Please note that the forms on this page may not submit without this enabled, please contact us directly instead of filling in these forms.");
    }
});

